import { Controller } from '@hotwired/stimulus'
import bootstrap from 'bootstrap/dist/js/bootstrap'

// Generic row-click detail modal: fetches a server-rendered partial from the
// row's URL param and shows it in the modal shell.
//
// Usage:
//   <div data-controller="record-modal">
//     <tr data-action="click->record-modal#open" data-record-modal-url-param="/admin/...">
//     <div class="modal fade" data-record-modal-target="modal">
//       <div class="modal-content" data-record-modal-target="content"></div>
export default class extends Controller {
  static targets = ['modal', 'content']

  open(event) {
    // Bound on a row, a click on a link or button inside it belongs to that
    // control. Bound on the control itself, the click is the point.
    const control = event.target.closest('a, button')
    if (control && control !== event.currentTarget) return

    fetch(event.params.url, { headers: { Accept: 'text/html' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Request failed: ${response.status}`)
        return response.text()
      })
      .then((html) => {
        this.contentTarget.innerHTML = html
        this.#modal().show()
      })
      .catch(() => {
        this.contentTarget.innerHTML =
          '<div class="modal-body text-danger">Failed to load details. Please try again.</div>'
        this.#modal().show()
      })
  }

  disconnect() {
    this.#modal().dispose()
    document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove())
    document.body.classList.remove('modal-open')
  }

  #modal() {
    return bootstrap.Modal.getOrCreateInstance(this.modalTarget)
  }
}
